'use strict';

angular.module('app')

.run(function (Article) {}) // jshint ignore:line

.factory('Article', function (DS, ArticlePage) {
    return DS.defineResource({
        name: 'Article',
        endpoint: 'articles',
        upsert: true,
        relations: {
            hasMany: {
                ArticlePage: {
                    localField: 'pages',
                    foreignKey: 'article_id'
                }
            },
            belongsTo: {
                Asset: {
                    localField: 'asset',
                    localKey: 'asset_id'
                },
                Category: {
                    localField: 'category',
                    localKey: 'category_id'
                }
            }
        },
        methods: {
            getPages: function ()
            {
                return ArticlePage.filter({
                    sort: 'display_order',
                    where: {
                        article_id: this.id,
                    }
                });
            }
        }
    });
});
